import ls from 'localstorage-slim';
export default {
  setConfiguratoins(state, data) {
    data.forEach((conf) => {
      if (conf.title == 'ShowTherapistPicture') {
        state.showTherapistPicture = conf.value;
        ls.set('showTherapistPicture', conf.value, {
          encrypt: true,
        });
      }
      if (conf.title == 'ShowTherapistPsychologyOrganizationLink') {
        state.showTherapistPsychologyOrganizationLink = conf.value;
        ls.set('showTherapistPsychologyOrganizationLink', conf.value, {
          encrypt: true,
        });
      }
      if (conf.title == 'ShowOtherAbilityFilter') {
        state.showOtherAbilityFilter = conf.value;
        ls.set('showOtherAbilityFilter', conf.value, {
          encrypt: true,
        });
      }
      if (conf.title == 'ShowApproachFilter') {
        state.showApproachFilter = conf.value;
        ls.set('showApproachFilter', conf.value, {
          encrypt: true,
        });
      }
      if (conf.title == 'ShowEducationDegreeFilter') {
        state.showEducationDegreeFilter = conf.value;
        ls.set('showEducationDegreeFilter', conf.value, {
          encrypt: true,
        });
      }
      if (conf.title == 'ShowAgeRangeFilter') {
        state.showAgeRangeFilter = conf.value;
        ls.set('showAgeRangeFilter', conf.value, {
          encrypt: true,
        });
      }
      if (conf.title == 'ShowGenderFilter') {
        state.showGenderFilter = conf.value;
        ls.set('showGenderFilter', conf.value, {
          encrypt: true,
        });
      }
      if (conf.title == 'ShowTopicFilter') {
        state.showTopicFilter = conf.value;
        ls.set('showTopicFilter', conf.value, {
          encrypt: true,
        });
      }
    });
  },
};
